// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1imDv","range":"MonthRangeSwitch_range__3F6CV","disabled":"MonthRangeSwitch_disabled__3uKyp"};